import { Text } from '@optiaxiom/react';

import { AgentExecutionItem } from '@frontend/types/agentExecution';

type AgentNameCellProps = {
  execution: AgentExecutionItem;
};

export function AgentNameCell({ execution }: AgentNameCellProps) {
  return (
    <Text fontSize="md" color="fg.tertiary">
      {execution.workflow_agent?.name || 'Unknown Agent'}
    </Text>
  );
}
